import type { AxiosError } from 'axios';

export async function handleApiCall<T>(
  apiCall: () => Promise<T>,
  loading: { value: boolean },
  error: { value: AxiosError | unknown | null },
  onSuccess?: (result: T) => void,
): Promise<T | undefined> {
  loading.value = true;
  error.value = null;

  try {
    const res = await apiCall();
    onSuccess?.(res);
    return res;
  } catch (err) {
    error.value = err;
    console.error(err);
    return undefined;
  } finally {
    loading.value = false;
  }
}
